import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BuildingItem = _resolveComponent("BuildingItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_component_ElScrollbar, { class: "card-list" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.buildings, (building, index) => {
        return (_openBlock(), _createBlock(_component_BuildingItem, {
          key: index,
          class: "building-card card--slim mx-3 my-2",
          building: building,
          plantAddressType: _ctx.currentEntrancePlant.addressingType,
          onClick: ($event: any) => (_ctx.buildingSelected(building))
        }, null, 8, ["building", "plantAddressType", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}